var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75047 8.12773L2.14797 5.52523C1.85547 5.23273 1.38297 5.23273 1.09047 5.52523C0.797969 5.81773 0.797969 6.29023 1.09047 6.58273L4.22547 9.71773C4.51797 10.0102 4.99047 10.0102 5.28297 9.71773L13.218 1.78273C13.5105 1.49023 13.5105 1.01773 13.218 0.725234C12.9255 0.432734 12.453 0.432734 12.1605 0.725234L4.75047 8.12773Z",
    fill: "#6FD231"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenMark);
export default __webpack_public_path__ + "static/media/greenMark.b9717147d290823a43d14a57868af55f.svg";
export { ForwardRef as ReactComponent };